import { MarkupOutput } from '../../../integrated-client/models';

export type MarkupsItemsList = Array<MarkupOutput>;

export class ResultsData {

  markupsList: MarkupsItemsList
  showMore: boolean

  constructor() {
    this.markupsList = [];
    this.showMore = false;
  }

}